export enum TicketState {
  WAITING_FOR_SUPPORT = "WAITING_FOR_SUPPORT",
  WAITING_FOR_CUSTOMER = "WAITING_FOR_CUSTOMER",
  CLOSED = "CLOSED",
}

export enum Product {
  CCF = "CCF",
  LKSG = "LKSG",
  ESG = "ESG",
  CSRD = "CSRD",
  PCF = "PCF",
  OTHER = "OTHER",
}

export interface SupportUserInfo {
  id: string;
  firstName: string;
  lastName: string;
}

interface Address {
  country: string;
  postalCode: string;
  city: string;
  street: string;
  house: string;
}

export interface CompanyInfo {
  id: string;
  name: string;
  industry: string;
  address: Address;
}

export interface TicketSearchModel {
  id: string;
  number: number;
  subject: string;
  state: TicketState;
  company: CompanyInfo;
  createdBy: SupportUserInfo;
  createdAt: number;
  product: string;
}
